// Import all gallery images
const galleryImages = import.meta.glob<{ default: string }>('../assets/gallery/*.{jpg,jpeg,png}', { eager: true });

// Import all banner images
const bannerImages = import.meta.glob<{ default: string }>('../assets/banners/*.{jpg,jpeg,png}', { eager: true });

// Import logo
const logo = new URL('../assets/logo.svg', import.meta.url).href;

// Helper function to ensure correct path in both development and production
const getImagePath = (path: string) => {
  if (import.meta.env.PROD) {
    // In production, we want to use absolute paths from the root
    return path.replace(/^\/src/, '').replace(/^\.\.\//, '/');
  }
  return path;
};

// Export organized gallery images
export const gallery = {
  events: [
    getImagePath(galleryImages['../assets/gallery/Event-1.jpg'].default),
    getImagePath(galleryImages['../assets/gallery/Event-2.jpg'].default),
    getImagePath(galleryImages['../assets/gallery/Event-3.jpg'].default),
    getImagePath(galleryImages['../assets/gallery/Event-4.jpg'].default),
    getImagePath(galleryImages['../assets/gallery/Event-5.jpg'].default),
  ],
  yoga: [
    getImagePath(galleryImages['../assets/gallery/yoga-1.jpg'].default),
    getImagePath(galleryImages['../assets/gallery/yoga-2.jpg'].default),
    getImagePath(galleryImages['../assets/gallery/yoga-3.jpg'].default),
    getImagePath(galleryImages['../assets/gallery/yoga-4.jpg'].default),
    getImagePath(galleryImages['../assets/gallery/yoga-5.jpg'].default),
  ],
  treatments: [
    getImagePath(galleryImages['../assets/gallery/Treatment-1.jpg'].default),
    getImagePath(galleryImages['../assets/gallery/Treatment-2.jpg'].default),
    getImagePath(galleryImages['../assets/gallery/Treatment-3.jpg'].default),
    getImagePath(galleryImages['../assets/gallery/Treatment-4.jpg'].default),
  ],
  camps: [
    getImagePath(galleryImages['../assets/gallery/camp-1.jpg'].default),
    getImagePath(galleryImages['../assets/gallery/camp-2.jpg'].default),
    getImagePath(galleryImages['../assets/gallery/camp-3.jpg'].default),
    getImagePath(galleryImages['../assets/gallery/camp-4.jpg'].default),
    getImagePath(galleryImages['../assets/gallery/camp-5.jpg'].default),
  ],
  team: [
    getImagePath(galleryImages['../assets/gallery/Loganathan.jpg'].default),
    getImagePath(galleryImages['../assets/gallery/Physician.jpg'].default),
    getImagePath(galleryImages['../assets/gallery/Physician-1.jpg'].default),
  ],
};

// Export banner images
export const banners = {
  home: getImagePath(bannerImages['../assets/banners/home-banners.jpg'].default),
  clinic1: getImagePath(bannerImages['../assets/banners/svsyn-clinic-banner-1.jpg'].default),
  clinic2: getImagePath(bannerImages['../assets/banners/svsyn-clinic-banner-2.jpg'].default),
};

// Export logo
export { logo }; 